import { ComponentMessageTypes, useConfigContext } from "@WahooFitness/wahoo-offline-mfe";
import { I18nProvider as LingUiI18Provider } from "@lingui/react";
import { useEffect } from "react";
import { i18n } from "@lingui/core";
import { getMessages as getUctMessages, uctMessagesEN } from "@WahooFitness/unit-convertr-ts";
import { getMessages as getRedesignrMessages } from "@WahooFitness/redesignr";
import { useIsSystm } from "@WahooFitness/wahoo-offline-mfe";
import { t } from "@lingui/macro";

async function getLocalizationData(
  specifiedLocale: string
): Promise<{ messages: Record<string, any> }> {
  try {
    const { messages: localeMessages } = await import(`../locales/${specifiedLocale}.po`);
    // use English fallbacks for any unresolved languages. These packages use explicit
    // keyed message IDs, so an empty catalog would render raw keys instead of English.
    const uctMessages = (getUctMessages(specifiedLocale) ?? getUctMessages("en"))?.messages ?? {};
    const redesignrMessages =
      (getRedesignrMessages(specifiedLocale) ?? getRedesignrMessages("en"))?.messages ?? {};
    return {
      messages: Object.assign({ ...localeMessages }, { ...uctMessages }, { ...redesignrMessages }),
    };
  } catch {
    try {
      //@ts-expect-error LingUI po files do not have a type export.
      const { messages: en_messages } = await import("../locales/en.po");
      return { messages: Object.assign({ ...en_messages }, { ...uctMessagesEN }) };
    } catch {
      return { messages: {} };
    }
  }
}

// These are localized strings used by offline MFE components.
const getComponentMessages = (): ComponentMessageTypes => ({
  pageLoadError: {
    friendlyErrorMessage: t`Sorry, something went wrong.`,
    devErrorMessage: t`Page Load Error (you are seeing this because you are special)`,
    reloadButtonText: t`Reload`,
  },
});

export const I18nProvider = ({ children }: any) => {
  const { locale: configLocale, setComponentLocalizedMessages } = useConfigContext();
  const { isSystm } = useIsSystm();
  const locale = isSystm ? "en" : configLocale;
  useEffect(() => {
    async function loadMessages() {
      const { messages } = await getLocalizationData(locale);
      i18n.loadAndActivate({ locale, messages });
      setComponentLocalizedMessages(getComponentMessages());
    }
    loadMessages();
  }, [locale, setComponentLocalizedMessages]);

  return <LingUiI18Provider i18n={i18n}>{children}</LingUiI18Provider>;
};
